import script from "./BookCoverStack.vue?vue&type=script&setup=true&lang=ts"
export * from "./BookCoverStack.vue?vue&type=script&setup=true&lang=ts"

import "./BookCoverStack.vue?vue&type=style&index=0&id=41da8313&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41da8313"]])

export default __exports__